module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"officeInterviewRecord":"Запись очного интервью"}}')
  delete Component.options._Ctor
}
